import type { ConsentText } from './types';

/**
 * The plot consent in Gujarati. Follows en.ts key for key and placeholder for placeholder (see types.ts).
 * Written to be read aloud by a field officer; a native reviewer should check it before use.
 */
export const gu: ConsentText = {
  selfName: 'ગુજરાતી',
  englishName: 'અંગ્રેજી',
  labels: {
    stageDraft: 'ખેડૂતને વાંચવા માટે - હજી સહી થયેલ નથી',
    stagePaper: 'ખેડૂતની સહી માટે',
    stageSigned: 'સંમતિ આપી દીધી છે',
    watermark: 'ડ્રાફ્ટ',
    kindDraft: 'ડ્રાફ્ટ સંમતિ',
    kindPaper: 'કાગળ પરની સંમતિ',
    kindDigital: 'ડિજિટલ સંમતિ',
    record: 'રેકોર્ડ',
    page: 'પાનું',
    generated: '{at} ના રોજ તૈયાર કરેલ',
    title: 'ખેડૂતની પોતાના પ્લોટ માટેની સંમતિ',
    plot: 'પ્લોટ',
    valid: 'માન્ય',
    validRange: '{from} થી {to} સુધી',
    membershipOfGroup: 'ખેડૂત ઉત્પાદક જૂથનું સભ્યપદ',
    farmerHeading: '1. ખેડૂત',
    name: 'નામ',
    memberCode: 'સભ્ય કોડ',
    fatherOrSpouse: 'પિતા / પતિ-પત્ની',
    gender: 'લિંગ',
    age: 'ઉંમર',
    address: 'સરનામું',
    mobile: 'મોબાઇલ',
    email: 'ઈમેલ',
    consentLanguage: 'સંમતિની ભાષા',
    programmesHeading: 'આ સંમતિ જે કાર્યક્રમોને લાગુ પડે છે',
    certificateReference: 'પ્રમાણપત્ર / સંદર્ભ',
    validUntil: '{date} સુધી માન્ય',
    inScope: '{org} ના કાર્યક્ષેત્રમાં',
    membership: 'સભ્યપદ',
    membershipValue: 'આ પ્લોટ {org} ના ખેડૂત ઉત્પાદક જૂથના ભાગ રૂપે',
    agreeFarmer: 'હું, {name}, પુષ્ટિ કરું છું કે ઉપરની વિગતો મારી છે અને સાચી છે. આગળનાં પાનાંમાં મારા પ્લોટ, મારી માહિતી અને પ્લોટ જે દરેક કાર્યક્રમમાં છે તેમાં હું શું સ્વીકારું છું તેનું વર્ણન છે. તે મને {languages} માં સમજાવવામાં આવ્યું છે, જે હું સમજું છું, અને હું આ સંમતિ મારી પોતાની મરજીથી આપું છું. હું ગમે ત્યારે તે પાછી ખેંચવા માટે કહી શકું છું.',
    plotHeading: '2. પ્લોટ',
    village: 'ગામ',
    location: 'સ્થાન',
    centre: 'કેન્દ્ર બિંદુ (અક્ષાંશ, રેખાંશ)',
    notMapped: 'સીમા હજી નકશામાં નોંધાઈ નથી',
    declaredArea: 'જાહેર કરેલ વિસ્તાર (જમીન રેકોર્ડ મુજબ)',
    mappedArea: 'નકશા મુજબ વિસ્તાર',
    tenure: 'જમીનનો હક (માલિકી / ભાડૂત)',
    landDocuments: 'જમીનના દસ્તાવેજો',
    trees: 'પ્લોટ પરનાં વૃક્ષો',
    excision: 'બાકાત રાખેલ વિસ્તારો (જાહેર કરેલ)',
    boundaryHeading: 'સીમા (GPS, અક્ષાંશ, રેખાંશ)',
    snapshotCaption: 'સેટેલાઇટ છબી પર સીમા',
    moreCorners: '... બીજા {n} ખૂણા, એપમાં સચવાયેલા',
    agreePlot: 'હું સંમત છું કે પાના 1 પરના કાર્યક્રમો માટે {org} આ પ્લોટની નોંધણી કરી શકે, તેનો નકશો બનાવી શકે અને તેની દેખરેખ રાખી શકે.',
    dataHeading: '3. મારી ભાગીદારી અને મારી માહિતી',
    dutiesHeading: 'કાર્યક્રમોમાં ભાગ લેનાર તરીકે, હું સંમત છું કે',
    informationHeading: 'મારા વિશે રાખવામાં આવતી માહિતી',
    collected: 'શું એકત્ર કરવામાં આવે છે',
    why: 'શા માટે',
    whoReceives: 'મારી માહિતી કોને મળી શકે',
    howLong: 'તે કેટલા સમય સુધી રાખવામાં આવે છે',
    myRights: 'મારા અધિકારો',
    toAsk: 'પૂછવા, ફરિયાદ કરવા કે સંમતિ પાછી ખેંચવા માટે',
    dataBoard: 'જો ઉકેલ ન આવે, તો હું ભારતના ડેટા પ્રોટેક્શન બોર્ડ (Data Protection Board of India) ને ફરિયાદ કરી શકું છું.',
    agreeData: 'આ સંમતિમાં વર્ણવેલા હેતુઓ માટે મારી માહિતી એકત્ર કરવામાં અને વાપરવામાં આવે તે માટે હું સંમત છું.',
    sharingHeading: '4. મારી માહિતી કેવી રીતે વાપરી અને વહેંચી શકાય',
    withdrawingHeading: 'મારી સંમતિ પાછી ખેંચવી',
    iAgreeTo: 'હું સંમત છું કે',
    iAmEntitled: 'મને આનો અધિકાર છે',
    agreeScope: 'પ્લોટ {plot} માટે {scope} મારી પાસેથી શું અપેક્ષા રાખે છે તે હું સમજ્યો/સમજી છું, અને હું તેની સાથે સંમત છું.',
    recordHeading: 'સંમતિનો રેકોર્ડ',
    consent: 'સંમતિ',
    consentValue: '{scopes} માટે પ્લોટની સંમતિ',
    farmer: 'ખેડૂત',
    recordId: 'રેકોર્ડ આઈડી',
    givenByOtp: 'OTP દ્વારા આપેલ સંમતિ',
    otpRef: 'OTP સંદર્ભ',
    documentSha: 'દસ્તાવેજનો SHA-256',
    signatureOf: '{name} ની સહી',
    thumb: 'અંગૂઠો',
    witness: 'સાક્ષી (નામ અને સહી)',
    date: 'તારીખ',
    witnessFull: 'સાક્ષીનું નામ અને સહી',
    officerFull: 'ફીલ્ડ અધિકારીનું નામ અને સહી',
    paperNote: 'કાગળ પર આપેલ: સાક્ષીની હાજરીમાં અહીં અને દરેક પાના પર સહી કરો અથવા અંગૂઠાનું નિશાન મૂકો. ફીલ્ડ અધિકારી આ સહી કરેલી નકલ અપલોડ કરશે.',
    otpSentence: '{name} ની સંમતિ {reached} પર મોકલેલા OTP દ્વારા લેવામાં આવી અને {day} ના રોજ {time} વાગ્યે{by} તેની ચકાસણી કરવામાં આવી.',
    otpBy: ' {officer} દ્વારા',
    registeredMobile: 'નોંધાયેલ મોબાઇલ',
    registeredEmail: 'નોંધાયેલ ઈમેલ',
    via: 'મારફતે',
    and: 'અને',
    registeredContact: 'નોંધાયેલ સંપર્ક',
    coversHeading: 'આ સંમતિ શું આવરી લે છે',
    partiesHeading: 'ખેડૂતની સાથે આ સંમતિ આપનાર વ્યક્તિઓ',
    relationship: 'સંબંધ',
    termsHeading: 'વ્યવસ્થાની શરતો',
    termsBlank: 'પેદાશ અથવા વેચાણની રકમમાં હિસ્સો: ______ %    કોને ચૂકવવું: ________________',
    partiesBlank: 'નામ હાથથી લખવાનાં છે, દરેકની નીચે તેમની સહી સાથે.',
    bothVersions: 'આ દસ્તાવેજ અંગ્રેજીમાં અને ખેડૂતની પોતાની ભાષા, એટલે કે આ ભાષામાં છે. બંને એક જ સંમતિ છે; ખેડૂતને આ સંમતિ આ જ ભાષામાં સમજાવવામાં આવી હતી.',
    partySignature: '{name} ની સહી અથવા અંગૂઠો',
    partiesNote: 'જેમનાં નામ લખેલાં છે તે દરેક વ્યક્તિ સાક્ષીની હાજરીમાં કાગળની નકલના આ પાના પર સહી કરે છે; ખેડૂત OTP અથવા સહી દ્વારા સંમતિ આપે છે.',
  },
  kinds: {
    sale: {
      title: 'પોતાના પ્લોટની પેદાશની કાપણી અને વેચાણ માટે ખેડૂતની સંમતિ',
      heading: 'આ પ્લોટમાંથી કાપણી અને વેચાણ',
      about: 'આ સંમતિ પ્લોટ {plot} પર કાપણી અને તેમાં થતી પેદાશ - લાકડું, થાંભલા, પલ્પવુડ, બળતણનું લાકડું, વાંસ કે બીજી પેદાશ - {org} મારફતે વેચવાને, અને દરેક વેચાણ કેવી રીતે નોંધાય અને ચૂકવાય તેને આવરી લે છે.',
      agreeLead: 'હું સંમત છું કે',
      obligations: [
        'ફક્ત {org} ની આંતરિક કાપણી પરમિટ અને કાયદા મુજબ જરૂરી વૃક્ષ કાપવાની અને પરિવહનની પરમિટ સાથે જ કાપણી કરીશ, અને ફક્ત નિશાન કરેલાં વૃક્ષો અને નક્કી કરેલો જથ્થો જ કાપીશ.',
        'દરેક કાપણીની જાત, વૃક્ષોની સંખ્યા અને કદ કે વજન સાચું જાહેર કરીશ, અને તેને માપવા, તેના ફોટા લેવા અને આ પ્લોટ સામે નોંધવા દઈશ.',
        'આ પ્લોટની જે પેદાશ પર પ્રમાણપત્ર કે વનનાશ-મુક્ત (deforestation-free) દાવો હોય તે ફક્ત {org} મારફતે અથવા તે જણાવે તે ખરીદનારને જ વેચીશ, અને તેમાં બીજે ક્યાંયની પેદાશ ક્યારેય નહીં ભેળવું.',
        'દરેક વેચાણ બિલ, રવાનગી ચિઠ્ઠી અને પરિવહનના કાગળો સાથે નોંધાવીશ, અને દરેક વેચાણનો જથ્થો અને રકમ મારા OTP અથવા સહી દ્વારા પુષ્ટિ કરીશ.',
        'ખરીદનાર, પ્રમાણન સંસ્થા કે સરકારી તંત્રને પેદાશ આ પ્લોટ સુધી શોધી કાઢવા માટે જરૂરી પ્લોટ, કાપણી અને વેચાણની વિગતો {org} ને આપવા દઈશ.',
        'નક્કી થયેલી કપાત - કાપણી અને પરિવહનનો ખર્ચ, એડવાન્સ, ખેતી-સામગ્રીની લોન અને જૂથની ફી - વેચાણની રકમમાંથી કાપવા દઈશ, જે મારા હિસાબપત્રમાં બતાવેલી હશે.',
        'કાપણી પછી વ્યવસ્થાપન યોજના મુજબ ફરીથી વાવેતર કરીશ, અથવા કુદરતી રીતે ફરી ઊગવા દઈશ.',
        'વૃક્ષો, જમીન કે પેદાશ અંગે કોઈ પણ વિવાદ હોય તો વેચાણ પહેલાં તરત {org} ને જણાવીશ.',
      ],
      rightsLead: 'મને આનો અધિકાર છે',
      rights: [
        'દરેક વેચાણની પુષ્ટિ કરું તે પહેલાં તેનો ભાવ, જથ્થો, કપાત અને ચોખ્ખી રકમ જાણવાનો, અને બિલની નકલ મેળવવાનો.',
        '{org} એ નક્કી કરેલા સમયમાં ચોખ્ખી રકમ મારા પોતાના બેંક ખાતામાં મેળવવાનો, અને દરેક ચુકવણી મારા હિસાબપત્રમાં જોવાનો.',
        'જે વેચાણનો ભાવ કે જથ્થો મને મંજૂર ન હોય તેનો ઇનકાર કરવાનો.',
        'મારા પ્લોટમાંથી થયેલા કોઈ પણ વેચાણના રેકોર્ડ માંગવાનો.',
      ],
      agree: 'હું, {name}, આ શરતો પર પ્લોટ {plot} ની પેદાશની કાપણી અને વેચાણ માટે સંમત છું. તે મને {languages} માં સમજાવવામાં આવી છે, જે હું સમજું છું, અને હું આ સંમતિ મારી પોતાની મરજીથી આપું છું. હું ગમે ત્યારે તે પાછી ખેંચવા માટે કહી શકું છું.',
      consentValue: 'પ્લોટમાંથી કાપણી અને વેચાણ માટે સંમતિ',
    },
    family: {
      title: 'પરિવારની માલિકીના પ્લોટ માટે પરિવારના સભ્યોની સંમતિ',
      heading: 'પરિવારના સભ્યોની સંમતિ',
      about: 'પ્લોટ {plot} પરિવારની સંયુક્ત માલિકીનો છે, અથવા વારસામાં મળ્યો છે અને હજી તેના ભાગ પડ્યા નથી. {name} તેની {org} સાથે નોંધણી કરાવે છે. નીચે જેમનાં નામ છે તે પરિવારના સભ્યો પુષ્ટિ કરે છે કે તેઓ આ જાણે છે અને તેની સાથે સંમત છે.',
      agreeLead: 'અમે, નીચે જેમનાં નામ છે તે પરિવારના સભ્યો, સંમત છીએ કે',
      obligations: [
        '{name} આ પ્લોટની {org} સાથે નોંધણી કરાવી શકે, તેનો નકશો બનાવડાવી શકે અને દેખરેખ રખાવી શકે, અને {name} એ જે કાર્યક્રમો માટે સંમતિ આપી છે તેમાં તેને સામેલ કરી શકે.',
        '{name} આ પ્લોટ પર કાપણીનું આયોજન કરી શકે અને કાપણી કરી શકે, અને તેની પેદાશ {org} મારફતે વેચી શકે.',
        'આ પ્લોટની પેદાશની ચુકવણી {name} ને કરી શકાય; તે પરિવારમાં કેવી રીતે વહેંચવી તે પરિવારની બાબત છે.',
        'આ પ્લોટના કોઈ પણ ભાગલા, વેચાણ, ગીરો કે વિવાદ વિશે, અને તે કોના હાથમાં છે તેમાં કોઈ ફેરફાર થાય તો તે વિશે અમે {org} ને જણાવીશું.',
        'આ સંમતિ ચાલુ હોય ત્યાં સુધી અમારામાંથી કોઈ આ પ્લોટની પેદાશ અલગથી કાપશે કે વેચશે નહીં, કે તેની બીજા કોઈ સાથે નોંધણી કરાવશે નહીં.',
        'અમારાં નામ, {name} સાથેનો અમારો સંબંધ અને અમારા સંપર્ક નંબર આ સંમતિ સાથે નોંધી શકાય.',
      ],
      rightsLead: 'અમે સમજીએ છીએ કે',
      rights: [
        'આ સંમતિથી જમીનનો માલિક કોણ છે કે તેમાં કોઈનો હિસ્સો કેટલો છે તેમાં કોઈ ફેરફાર થતો નથી.',
        'અમારામાંથી કોઈ પણ આ સંમતિ પાછી ખેંચવા માટે કહી શકે; ત્યારે {org} ચકાસશે કે પ્લોટ નોંધાયેલો રહી શકે કે નહીં.',
        'અમારામાંથી દરેક માંગણી કરીને, {name} અથવા {org} મારફતે, પ્લોટના રેકોર્ડ, કાપણી અને વેચાણ જોઈ શકે.',
      ],
      agree: 'અમને, ઉપર જેમનાં નામ છે તે પરિવારના સભ્યોને, અને મને, {name} ને, આ સંમતિ {languages} માં સમજાવવામાં આવી છે, જે અમે સમજીએ છીએ, અને અમે તે અમારી પોતાની મરજીથી આપીએ છીએ.',
      consentValue: 'પ્લોટ માટે પરિવારના સભ્યોની સંમતિ',
    },
    sharecrop: {
      title: 'પ્લોટ માટે જમીન માલિક અને ભાગિયા (ભાગીદાર ખેડૂત) ની સંમતિ',
      heading: 'જમીન માલિક અને ભાગિયાની સંમતિ',
      about: 'પ્લોટ {plot} પર ભાગિયા વ્યવસ્થા (bargadar / adhiar) હેઠળ ખેતી થાય છે. પ્લોટની {org} સાથે નોંધણી થાય, તેની કાપણી થાય અને તેની પેદાશ વેચાય તે પહેલાં નીચે જેમનાં નામ છે તે જમીન માલિક અને ભાગિયા બંને સંમતિ આપે છે.',
      agreeLead: 'અમે, જમીન માલિક અને ભાગિયા, સંમત છીએ કે',
      obligations: [
        'પ્લોટની {org} સાથે નોંધણી થઈ શકે, તેનો નકશો બનાવી શકાય અને દેખરેખ રાખી શકાય, અને તેના માટે સંમતિ અપાયેલા કાર્યક્રમોમાં તેને સામેલ કરી શકાય.',
        'પેદાશમાં અથવા વેચાણની રકમમાં હિસ્સો નીચેની શરતોમાં લખ્યા મુજબ રહેશે; {org} વેચાણના રેકોર્ડ પર દરેક વ્યક્તિનો હિસ્સો બતાવશે.',
        'કાપણીનું આયોજન અને કાપણી ભાગિયા જમીન માલિકની જાણમાં, {org} ની આંતરિક કાપણી પરમિટ અને કાયદા મુજબ જરૂરી દરેક પરમિટ હેઠળ કરશે.',
        'પ્લોટની પેદાશ {org} મારફતે વેચાશે, આ પ્લોટ સામે નોંધાશે, અને તેમાં બીજે ક્યાંયની પેદાશ ક્યારેય ભેળવાશે નહીં.',
        'ચુકવણી નીચેની શરતો મુજબ થશે: અમારામાંથી દરેકને પોતાનો હિસ્સો, અથવા તે મેળવવા માટે જેનું નામ લખ્યું હોય તે વ્યક્તિને.',
        'વ્યવસ્થામાં કોઈ ફેરફાર, કોઈ વિવાદ, કે વ્યવસ્થા પૂરી થાય તો અમારામાંથી કોઈ પણ તરત {org} ને જણાવશે.',
      ],
      rightsLead: 'અમે સમજીએ છીએ કે',
      rights: [
        'આ સંમતિ ફક્ત વ્યવસ્થાની નોંધ કરે છે; તેનાથી જમીનની માલિકીમાં, કે કાયદા હેઠળ ભાગિયાના કોઈ પણ હકમાં ફેરફાર થતો નથી.',
        'અમારામાંથી દરેક પ્લોટની કાપણી અને વેચાણના રેકોર્ડ, અને દરેક વેચાણમાં પોતાનો હિસ્સો જોઈ શકે.',
        'અમારામાંથી કોઈ પણ આ સંમતિ પાછી ખેંચવા માટે કહી શકે; ત્યારે {org} ચકાસશે કે પ્લોટ નોંધાયેલો રહી શકે કે નહીં.',
      ],
      agree: 'અમને, ઉપર જેમનાં નામ છે તે જમીન માલિક અને ભાગિયાને, આ સંમતિ {languages} માં સમજાવવામાં આવી છે, જે અમે સમજીએ છીએ, અને અમે તે અમારી પોતાની મરજીથી આપીએ છીએ.',
      consentValue: 'પ્લોટ માટે જમીન માલિક અને ભાગિયાની સંમતિ',
    },
    representative: {
      title: 'પ્રતિનિધિ નીમવા માટે ખેડૂતની સંમતિ',
      heading: 'પ્રતિનિધિ',
      about: '{name} નીચે જેમનું નામ છે તે વ્યક્તિને {org} સાથે પોતાના વતી કામ કરવા માટે નીમે છે - ફક્ત નીચે ટિક કરેલી બાબતોમાં અને ફક્ત જણાવેલા પ્લોટ માટે.',
      agreeLead: 'હું સંમત છું કે',
      obligations: [
        'મારા પ્રતિનિધિ ફક્ત ઉપર ટિક કરેલી બાબતોમાં અને ફક્ત જણાવેલા પ્લોટ માટે કામ કરશે; બાકીની દરેક બાબત માટે મારી જરૂર રહેશે.',
        'આ બાબતોમાં મારા પ્રતિનિધિ જે પુષ્ટિ કરે, તે મને એ રીતે લાગુ પડશે જાણે મેં પોતે પુષ્ટિ કરી હોય.',
        '{org} આ બાબતોના સંદેશા અને કોડ મારા પ્રતિનિધિને તેમના પોતાના મોબાઇલ નંબર પર મોકલી શકે.',
        'જો મારા પ્રતિનિધિએ હવે મારા વતી કામ ન કરવું જોઈએ, તો હું તરત {org} ને જણાવીશ.',
      ],
      rightsLead: 'હું સમજું છું કે',
      rights: [
        'સભ્ય અને મારા પ્લોટનો ધારક હું જ રહું છું; પ્રતિનિધિ નીમવાથી મારી જમીન, મારી પેદાશ કે મારી ચુકવણી બીજાને તબદીલ થતી નથી.',
        'હું લખીને બીજી રીતે મંજૂરી ન આપું ત્યાં સુધી, મારી પેદાશની ચુકવણી મારા પોતાના ખાતામાં જ થશે.',
        'હું આ નિમણૂક ગમે ત્યારે પૂરી કરી શકું છું; વધુમાં વધુ તે બતાવેલી તારીખે પૂરી થાય છે.',
      ],
      agree: 'હું, {name}, મારા પ્રતિનિધિને આ શરતો પર નીમું છું, અને મારા પ્રતિનિધિ તે સ્વીકારે છે. તે અમને {languages} માં સમજાવવામાં આવી છે, જે અમે સમજીએ છીએ, અને અમે આ સંમતિ અમારી પોતાની મરજીથી આપીએ છીએ.',
      consentValue: 'પ્રતિનિધિની નિમણૂક',
      powersHeading: 'જે બાબતોમાં પ્રતિનિધિ કામ કરી શકે',
      powers: {
        acknowledge: 'તેમના પોતાના મોબાઇલ પર મોકલેલા કોડથી, મારા વતી સંમતિઓ અને રેકોર્ડ સ્વીકારવા',
        confirmSale: 'મારા વેચાણની માત્રા અને રકમની પુષ્ટિ કરવી',
        receivePayment: 'મારી ચુકવણીની સૂચનાઓ મેળવવી',
      },
      plotsAll: 'મારા બધા પ્લોટ',
      plotsSome: 'પ્લોટ: {plots}',
    },
    dataProcessing: {
      title: 'પોતાની માહિતી એકત્ર કરવા અને વાપરવા માટે ખેડૂતની સંમતિ',
      heading: 'મારી માહિતી',
      about: '{org} {name} વિશેની માહિતી એકત્ર કરે છે અને રાખે છે, જેથી તેમને સભ્ય તરીકે નોંધી શકાય અને તેઓ જે કાર્યક્રમો, વેચાણ અને ચુકવણીઓમાં ભાગ લે છે તે ચલાવી શકાય. આ સંમતિ તે માહિતી અને તે કેવી રીતે વપરાય છે તેને આવરી લે છે.',
      agreeLead: 'હું સંમત છું કે',
      obligations: [
        '{org} મારું નામ, કુટુંબની વિગતો, સરનામું, ફોન અને ઈમેલ, ફોટોગ્રાફ, ઓળખપત્ર અને જમીનના દસ્તાવેજોના નંબર (છુપાવીને રાખેલા), અને મારા પ્લોટ, કાપણી, વેચાણ અને ચુકવણીઓની વિગતો એકત્ર કરી શકે.',
        'આ માહિતી મારી નોંધણી કરવા, મારી ઓળખ અને મારી જમીનની ચકાસણી કરવા, હું જે કાર્યક્રમોમાં જોડાઉં તે ચલાવવા, અને મારી પેદાશની નોંધ રાખવા અને તેની ચુકવણી કરવા માટે વાપરી શકાય.',
        'તે ફક્ત દરેક કાર્યક્રમ, વેચાણ કે દસ્તાવેજ માટે હું જે સંમતિ આપું તે મુજબ જ, અને કાયદો માંગે ત્યાં સરકારી સત્તાવાળાઓ સાથે, વહેંચી શકાય.',
        'હું મારી વિગતો અદ્યતન રાખીશ, અને તેમાં ફેરફાર થાય ત્યારે {org} ને જણાવીશ.',
      ],
      rightsLead: 'મને આનો અધિકાર છે',
      rights: [
        'મારા વિશે રાખેલી માહિતી જોવાનો, અને તેને સુધારાવવાનો કે પૂરી કરાવવાનો.',
        'કોઈ કાયદા કે કાર્યક્રમને તેની જરૂર ન રહે ત્યારે તેને ભૂંસાવવાનો.',
        'ગમે ત્યારે આ સંમતિ પાછી ખેંચવાનો; જે માહિતી પહેલેથી વપરાઈ ગઈ હોય તે કાયદો કે કોઈ કાર્યક્રમ માંગે ત્યાં સાચવી રાખવામાં આવી શકે છે.',
        'મારા વતી કામ કરવા માટે કોઈને નીમવાનો, અને મારી ચિંતાનો ઉકેલ ન આવે તો ભારતના ડેટા પ્રોટેક્શન બોર્ડ (Data Protection Board of India) ને ફરિયાદ કરવાનો.',
      ],
      agree: 'હું, {name}, વર્ણવ્યા મુજબ મારી માહિતી એકત્ર કરવામાં અને વાપરવામાં આવે તે માટે સંમત છું. તે મને {languages} માં સમજાવવામાં આવ્યું છે, જે હું સમજું છું, અને હું આ સંમતિ મારી પોતાની મરજીથી આપું છું.',
      consentValue: 'માહિતી એકત્ર કરવા અને વાપરવા માટે સંમતિ',
    },
    trading: {
      title: 'ખેડૂત ઉત્પાદક જૂથ મારફતે પોતાની પેદાશ વેચવા માટે ખેડૂતની સંમતિ',
      heading: 'મારી પેદાશનું વેચાણ',
      about: '{name} {org} મારફતે પેદાશ વેચે છે. આ સંમતિ વેચાણ કેવી રીતે થાય, નોંધાય, તેની પુષ્ટિ થાય અને તેની ચુકવણી થાય તેને આવરી લે છે.',
      agreeLead: 'હું સંમત છું કે',
      obligations: [
        'જે પેદાશ પર પ્રમાણપત્ર કે વનનાશ-મુક્ત (deforestation-free) દાવો હોય તે ફક્ત {org} મારફતે અથવા તે જણાવે તે ખરીદનારને જ વેચીશ, અને તેમાં બીજે ક્યાંયની પેદાશ ક્યારેય નહીં ભેળવું.',
        'દરેક વેચાણ બિલ, રવાનગી ચિઠ્ઠી અને પરિવહનના કાગળો સાથે નોંધાવીશ, અને તેનો જથ્થો અને રકમ મારા OTP અથવા સહી દ્વારા પુષ્ટિ કરીશ.',
        'પેદાશનો પત્તો રાખવા માટે, વેચાણ, પેદાશ અને તે ક્યાંથી આવી તેની વિગતો ખરીદનાર, પ્રમાણન સંસ્થાઓ અને સરકારી તંત્ર સાથે {org} ને વહેંચવા દઈશ.',
        'નક્કી થયેલી કપાત - એડવાન્સ, ખેતી-સામગ્રીની લોન, પરિવહન અને જૂથની ફી - વેચાણની રકમમાંથી કાપવા દઈશ, જે મારા હિસાબપત્રમાં બતાવેલી હશે.',
      ],
      rightsLead: 'મને આનો અધિકાર છે',
      rights: [
        'દરેક વેચાણની પુષ્ટિ કરું તે પહેલાં તેનો ભાવ, જથ્થો, કપાત અને ચોખ્ખી રકમ જાણવાનો, અને બિલની નકલ મેળવવાનો.',
        'નક્કી થયેલા સમયમાં મારા પોતાના બેંક ખાતામાં ચુકવણી મેળવવાનો, અને દરેક ચુકવણી મારા હિસાબપત્રમાં જોવાનો.',
        'જે વેચાણનો ભાવ કે જથ્થો મને મંજૂર ન હોય તેનો ઇનકાર કરવાનો.',
      ],
      agree: 'હું, {name}, આ માટે સંમત છું. તે મને {languages} માં સમજાવવામાં આવ્યું છે, જે હું સમજું છું, અને હું આ સંમતિ મારી પોતાની મરજીથી આપું છું. હું ગમે ત્યારે તે પાછી ખેંચવા માટે કહી શકું છું.',
      consentValue: 'ખેડૂત ઉત્પાદક જૂથ મારફતે વેચાણ માટે સંમતિ',
    },
    documentShare: {
      title: 'પોતાના દસ્તાવેજો વહેંચવા માટે ખેડૂતની સંમતિ',
      heading: 'મારા દસ્તાવેજો વહેંચવા',
      about: '{org} ને {name}, તેમના પ્લોટ કે તેમની પેદાશ વિશેના દસ્તાવેજો કોઈ ખરીદનાર, ઓડિટર કે સરકારી તંત્રને બતાવવાની જરૂર પડી શકે. આ સંમતિ તે એક સુરક્ષિત લિંક દ્વારા વહેંચવાને આવરી લે છે.',
      agreeLead: 'હું સંમત છું કે',
      obligations: [
        '{org} મારા રેકોર્ડ અને દસ્તાવેજોની નકલો - જમીન, પ્રમાણપત્ર, કાપણી, વેચાણ અને પત્તો રાખવાના દસ્તાવેજો - દરેક વહેંચણીમાં જેનું નામ લખ્યું હોય તે વ્યક્તિ સાથે, તેમાં જણાવેલા હેતુ માટે, વહેંચી શકે.',
        'દરેક વહેંચણી એક સુરક્ષિત લિંક તરીકે મોકલવામાં આવે છે, જેની મુદત પૂરી થાય છે, અને તેને ખોલવા માટે કોડની જરૂર પડી શકે.',
        'વહેંચેલા દસ્તાવેજો પરના ઓળખ નંબરો છુપાવીને રાખવામાં આવે છે, સિવાય કે કાયદો તે પૂરા માંગે.',
      ],
      rightsLead: 'મને આનો અધિકાર છે',
      rights: [
        'શું વહેંચવામાં આવ્યું, કોની સાથે અને ક્યારે, તે જાણવાનો.',
        'જે વહેંચણી હજી ખોલવામાં ન આવી હોય તે બંધ કરવા {org} ને કહેવાનો.',
        'આગળની વહેંચણીઓ માટે ગમે ત્યારે આ સંમતિ પાછી ખેંચવાનો.',
      ],
      agree: 'હું, {name}, આ માટે સંમત છું. તે મને {languages} માં સમજાવવામાં આવ્યું છે, જે હું સમજું છું, અને હું આ સંમતિ મારી પોતાની મરજીથી આપું છું. હું ગમે ત્યારે તે પાછી ખેંચવા માટે કહી શકું છું.',
      consentValue: 'દસ્તાવેજો વહેંચવા માટે સંમતિ',
    },
    payment: {
      title: 'પોતાને ચુકવણી કેવી રીતે થાય તે માટે ખેડૂતની સંમતિ',
      heading: 'મારી ચુકવણીઓ',
      about: '{org} {name} ને તેમની પેદાશ અને સેવાઓ માટે ચુકવણી કરે છે. આ સંમતિ ચુકવણી ક્યાં કરવામાં આવે અને તે કેવી રીતે નોંધાય તેને આવરી લે છે.',
      agreeLead: 'હું સંમત છું કે',
      obligations: [
        'હું લખીને બીજા ખાતાને મંજૂરી ન આપું ત્યાં સુધી, મને ચુકવણી રેકોર્ડમાં નોંધાયેલા મારા પોતાના બેંક ખાતામાં જ થશે.',
        'નક્કી થયેલી કપાત - એડવાન્સ, ખેતી-સામગ્રીની લોન, જૂથની ફી અને કાયદા મુજબ જરૂરી કર - ચુકવણી પહેલાં કાપી શકાય, અને તે મારા હિસાબપત્રમાં બતાવેલી હશે.',
        'મારું બેંક ખાતું બદલાય તો હું તરત {org} ને જણાવીશ, અને દરેક ચુકવણી મારા હિસાબપત્રમાં તપાસીશ.',
        'ચુકવણીની સૂચનાઓ મારા નોંધાયેલા મોબાઇલ, ઈમેલ કે WhatsApp પર મોકલી શકાય.',
      ],
      rightsLead: 'મને આનો અધિકાર છે',
      rights: [
        'દરેક બાકી રકમ, દરેક કપાત અને દરેક ચુકવણી બતાવતું હિસાબપત્ર મેળવવાનો.',
        'કોઈ પણ ચુકવણી કે કપાત વિશે પ્રશ્ન કરવાનો અને તેની સમજૂતી મેળવવાનો.',
        'ગમે ત્યારે આ સંમતિ પાછી ખેંચવાનો; પહેલેથી થયેલી ચુકવણીઓ માન્ય રહે છે.',
      ],
      agree: 'હું, {name}, આ માટે સંમત છું. તે મને {languages} માં સમજાવવામાં આવ્યું છે, જે હું સમજું છું, અને હું આ સંમતિ મારી પોતાની મરજીથી આપું છું. હું ગમે ત્યારે તે પાછી ખેંચવા માટે કહી શકું છું.',
      consentValue: 'ચુકવણી માટે સંમતિ',
    },
    membership: {
      title: 'ખેડૂત ઉત્પાદક જૂથના સભ્યપદ માટે ખેડૂતની સંમતિ',
      heading: 'સભ્યપદ',
      about: '{name} {org} ના ખેડૂત ઉત્પાદક જૂથમાં જોડાય છે. આ સંમતિ તેમના માટે સભ્યપદનો શો અર્થ છે તેને આવરી લે છે.',
      agreeLead: 'સભ્ય તરીકે, હું સંમત છું કે',
      obligations: [
        'જૂથના નિયમો અને હું જે કાર્યક્રમોમાં જોડાઉં તેની જરૂરિયાતોનું પાલન કરીશ, અને તેની તાલીમ, નિરીક્ષણો અને બેઠકોમાં ભાગ લઈશ.',
        'સાચા રેકોર્ડ રાખીશ, અને બીજે ક્યાંયની પેદાશને ક્યારેય મારી પોતાની પેદાશ તરીકે નહીં ખપાવું.',
        'મારી જમીન, તેની માલિકી કે તેના ઉપયોગમાં કોઈ પણ ફેરફાર થાય તો {org} ને જણાવીશ.',
      ],
      rightsLead: 'સભ્ય તરીકે, મને આનો અધિકાર છે',
      rights: [
        'જૂથના કાર્યક્રમો અને વેચાણમાં ભાગ લેવાનો, અને મને અસર કરતા તેના નિર્ણયો વિશે જાણ મેળવવાનો.',
        'કોઈ ચિંતા કે ફરિયાદ રજૂ કરવાનો, અને તેના કારણે મારી સાથેના વર્તન પર કોઈ અસર ન પડે.',
        'જૂથ છોડવાનો; મારા કાર્યક્રમો અને વેચાણ માટે તેનો શો અર્થ છે તે {org} મને સમજાવશે.',
      ],
      agree: 'હું, {name}, આ માટે સંમત છું. તે મને {languages} માં સમજાવવામાં આવ્યું છે, જે હું સમજું છું, અને હું આ સંમતિ મારી પોતાની મરજીથી આપું છું. હું ગમે ત્યારે તે પાછી ખેંચવા માટે કહી શકું છું.',
      consentValue: 'સભ્યપદ માટે સંમતિ',
    },
    portalAccess: {
      title: 'ઓનલાઇન પોર્ટલ વાપરવા માટે ખેડૂતની સંમતિ',
      heading: 'ઓનલાઇન ઉપયોગ',
      about: '{org} {name} ને પોતાના રેકોર્ડ ઓનલાઇન જોવાની સુવિધા આપે છે; તેઓ પોતાના નોંધાયેલા મોબાઇલ કે ઈમેલ પર મોકલેલા કોડથી સાઇન ઇન કરે છે.',
      agreeLead: 'હું સંમત છું કે',
      obligations: [
        'મને મોકલેલા કોડ ખાનગી રાખીશ, અને {org} ના કર્મચારીઓ સહિત કોઈની સાથે ક્યારેય વહેંચીશ નહીં.',
        'પોર્ટલ ફક્ત મારા પોતાના રેકોર્ડ માટે જ વાપરીશ, અને જો મને લાગે કે બીજા કોઈએ મારું ખાતું વાપર્યું છે તો તરત {org} ને જણાવીશ.',
        'મારું ખાતું સુરક્ષિત રાખવા માટે, હું ક્યારે અને ક્યાંથી સાઇન ઇન કરું છું તે {org} ને નોંધવા દઈશ.',
      ],
      rightsLead: 'મને આનો અધિકાર છે',
      rights: [
        'મારા રેકોર્ડ, પ્લોટ, કાપણી, વેચાણ, ચુકવણીઓ અને સંમતિઓ ઓનલાઇન જોવાનો.',
        'માંગણી કરીને ગમે ત્યારે મારો ઓનલાઇન ઉપયોગ બંધ કરાવવાનો.',
      ],
      agree: 'હું, {name}, આ માટે સંમત છું. તે મને {languages} માં સમજાવવામાં આવ્યું છે, જે હું સમજું છું, અને હું આ સંમતિ મારી પોતાની મરજીથી આપું છું. હું ગમે ત્યારે તે પાછી ખેંચવા માટે કહી શકું છું.',
      consentValue: 'પોર્ટલના ઉપયોગ માટે સંમતિ',
    },
    harvestRequest: {
      title: 'પોતાના પ્લોટ પર કાપણી માટે ખેડૂતની સંમતિ',
      heading: 'કાપણી',
      about: '{name} {org} ને પોતાના પ્લોટ પર કાપણીની વ્યવસ્થા કરવા કે તેની મંજૂરી આપવા કહે છે. આ સંમતિ કાપણીનું આયોજન, કાપણી અને તેની નોંધ કેવી રીતે થાય તેને આવરી લે છે.',
      agreeLead: 'હું સંમત છું કે',
      obligations: [
        'ફક્ત {org} ની આંતરિક કાપણી પરમિટ અને કાયદા મુજબ જરૂરી દરેક પરમિટ હેઠળ, ફક્ત નિશાન કરેલાં વૃક્ષો અને નક્કી કરેલો જથ્થો જ કાપીશ.',
        'કાપણીને માપવા, તેના ફોટા લેવા અને મારા પ્લોટ સામે નોંધવા દઈશ, અને તે પછી સ્થળની તપાસ થવા દઈશ.',
        'વ્યવસ્થાપન યોજના મુજબ ફરીથી વાવેતર કરીશ, અથવા કુદરતી રીતે ફરી ઊગવા દઈશ.',
      ],
      rightsLead: 'મને આનો અધિકાર છે',
      rights: [
        'કાપણી શરૂ થાય તે પહેલાં નિશાન કરેલાં વૃક્ષો અને અંદાજેલો જથ્થો જાણવાનો.',
        'મારા પ્લોટનો કાપણીનો રેકોર્ડ અને ઉપજનું હિસાબપત્ર જોવાનો.',
      ],
      agree: 'હું, {name}, આ માટે સંમત છું. તે મને {languages} માં સમજાવવામાં આવ્યું છે, જે હું સમજું છું, અને હું આ સંમતિ મારી પોતાની મરજીથી આપું છું. હું ગમે ત્યારે તે પાછી ખેંચવા માટે કહી શકું છું.',
      consentValue: 'કાપણી માટે સંમતિ',
    },
    eudrClaim: {
      title: 'પોતાની પેદાશ પર EUDR અને FSC દાવા માટે ખેડૂતની સંમતિ',
      heading: 'મારી પેદાશ પરના દાવા',
      about: '{org} {name} ના પ્લોટની પેદાશ EUDR વનનાશ-મુક્ત (deforestation-free) દાવા અથવા FSC દાવા સાથે વેચે છે. આ સંમતિ તે દાવાઓ માટે જરૂરી માહિતીને આવરી લે છે.',
      agreeLead: 'હું સંમત છું કે',
      obligations: [
        'મારા પ્લોટનું ભૌગોલિક સ્થાન, અને મારી કાપણી અને વેચાણના રેકોર્ડ, ડ્યુ ડિલિજન્સ નિવેદનો અને દાવાના રેકોર્ડમાં ખરીદદારો અને સત્તાવાળાઓ સાથે વહેંચી શકાય.',
        'મારા પ્લોટ જરૂરિયાતો પૂરી કરે ત્યાં સુધી જ પેદાશ દાવા સાથે વેચાય છે, અને હું બીજે ક્યાંયની પેદાશ અલગ રાખીશ.',
        'નિયમ મુજબ, આ માહિતી ઓછામાં ઓછાં પાંચ વર્ષ સુધી રાખી શકાય.',
      ],
      rightsLead: 'મને આનો અધિકાર છે',
      rights: [
        'મારા પ્લોટ વિશે શું વહેંચવામાં આવે છે, અને કોની સાથે, તે જાણવાનો.',
        'મારી પેદાશ પરથી કોઈ દાવો પાછો ખેંચાય તો તે વિશે, અને તેનું કારણ, જાણવાનો.',
      ],
      agree: 'હું, {name}, આ માટે સંમત છું. તે મને {languages} માં સમજાવવામાં આવ્યું છે, જે હું સમજું છું, અને હું આ સંમતિ મારી પોતાની મરજીથી આપું છું. હું ગમે ત્યારે તે પાછી ખેંચવા માટે કહી શકું છું.',
      consentValue: 'EUDR અને FSC દાવા માટે સંમતિ',
    },
    withdrawal: {
      title: 'ખેડૂત દ્વારા સંમતિ પાછી ખેંચવી',
      heading: 'સંમતિ પાછી ખેંચવી',
      about: '{name} નીચે બતાવેલા પ્લોટ કે સભ્યપદ માટે {org} ને આપેલી પોતાની સંમતિ પાછી ખેંચે છે.',
      agreeLead: 'હું સમજું છું કે',
      obligations: [
        'તે લાગુ પડે તે તારીખથી, બતાવેલા પ્લોટ કાર્યક્રમોમાં નોંધાયેલા રહેતા નથી, અને {org} મારફતે તેમાંથી કોઈ નવી કાપણી કે વેચાણ થતું નથી.',
        'પહેલેથી વપરાયેલી કે વહેંચાયેલી માહિતી કાયદો, કોઈ પ્રમાણપત્ર કે કાર્યક્રમ માંગે ત્યાં સાચવી રાખવામાં આવી શકે છે.',
        'મને મળવાપાત્ર બાકી ચુકવણીઓ પહેલાંની જેમ જ થશે.',
      ],
      rightsLead: 'મને આનો અધિકાર છે',
      rights: [
        'સંમતિ પાછી ખેંચવાથી મારાં વેચાણ, ચુકવણીઓ અને કાર્યક્રમો પર શી અસર થાય છે તે જાણવાનો.',
        'પછીથી, નવી સંમતિ તરીકે, ફરી સંમતિ આપવાનો.',
      ],
      agree: 'હું, {name}, બતાવ્યા મુજબ મારી સંમતિ પાછી ખેંચું છું. તે મને {languages} માં સમજાવવામાં આવ્યું છે, જે હું સમજું છું, અને હું આ મારી પોતાની મરજીથી કરું છું.',
      consentValue: 'સંમતિ પાછી ખેંચવી',
      plots: 'પાછા ખેંચેલા પ્લોટ',
      reason: 'કારણ',
      effective: 'આ તારીખથી લાગુ',
      allPlots: 'સભ્યપદ અને બધા પ્લોટ',
    },
    amendment: {
      title: 'ખેડૂતની સંમતિમાં સુધારો',
      heading: 'શું બદલાય છે',
      about: 'માત્ર નીચેની બાબતો બદલાય છે. સહી કરેલી સંમતિનો બાકીનો દરેક શબ્દ જેમ હતો તેમ જ રહે છે.',
      agreeLead: 'શું તેમનું તેમ રહે છે',
      obligations: [
        'ખેતર, તેની સીમા અને તેના ખૂણા, જેમ સહી કરેલી સંમતિમાં નોંધાયેલા છે.',
        '{org} મારી માહિતી સાથે શું કરી શકે, અને કોની સાથે વહેંચી શકે.',
        'ગમે ત્યારે, નિઃશુલ્ક, મારી સંમતિ પાછી ખેંચવાનો મારો અધિકાર.',
      ],
      rightsLead: 'મને અધિકાર છે',
      rights: [
        'સહી કરતાં પહેલાં આ સુધારો મને સમજાય તેવી ભાષામાં મને વાંચી સંભળાવવામાં આવે.',
        'તેને નકારવાનો: ત્યારે મારી સંમતિ મેં સહી કરી હતી તેવી જ રહે છે.',
      ],
      agree: 'હું, {name}, પુષ્ટિ કરું છું કે બતાવેલા ફેરફારો મેં માગ્યા હતા, તે મને {languages} માં સમજાવવામાં આવ્યા, અને હું તેમની સાથે સંમત છું. મારી સંમતિમાં બાકીનું બધું મેં સહી કર્યા મુજબ જ રહે છે.',
      consentValue: 'સંમતિમાં સુધારો નં. {n}',
      numbered: 'સુધારો નં. {n}',
      originalHeading: 'આ સુધારો કઈ સંમતિનો',
      consentAmended: 'સુધારેલી સંમતિ',
      givenOn: 'આપ્યા તારીખ',
      askedFor: 'સુધારો માગ્યા તારીખ',
      reason: 'કારણ',
      item: 'બાબત', was: 'પહેલાં', now: 'હવે',
      changeItems: { mobile: 'મોબાઇલ', email: 'ઈમેઇલ', address: 'સરનામું', valid_to: 'માન્ય સુધી', scope_codes: 'આ સંમતિ કયા કાર્યક્રમો માટે', rights_holder: 'હકદારનું નામ', other: 'અન્ય' },
    },
  },
  genders: { female: 'સ્ત્રી', male: 'પુરુષ', other: 'અન્ય', undisclosed: 'જણાવવા માંગતા નથી' },
  commonRights: [
    'મારા પ્લોટ પર શું જોવા મળ્યું અને શા માટે, તે મને જણાવવામાં આવે, અને તેના વિશે કોઈ પણ નિર્ણય લેવાય તે પહેલાં મને જવાબ આપવાની તક મળે.',
    'કોઈ ચિંતા કે ફરિયાદ રજૂ કરવાનો, અને તેના કારણે મારી સાથેના વર્તન પર કોઈ અસર ન પડે.',
    'ગમે ત્યારે મારી સંમતિ પાછી ખેંચવા માટે કહેવાનો; આ કાર્યક્રમમાં મારી ભાગીદારી પર તેની શું અસર થઈ શકે તે {org} મને સમજાવશે.',
  ],
  scopes: {
    FSC_FM: {
      title: 'FSC વન વ્યવસ્થાપન (જૂથ પ્રમાણપત્ર)',
      about: 'ફોરેસ્ટ સ્ટુઅર્ડશિપ કાઉન્સિલ (FSC) પ્રમાણિત કરે છે કે વૃક્ષો જવાબદારીપૂર્વક ઉગાડવામાં અને કાપવામાં આવે છે. મારો પ્લોટ {org} ના FSC જૂથના સભ્ય તરીકે પ્રમાણિત છે.',
      obligations: [
        'મારી જમીન પર કાયદાનું પાલન કરવું: જમીનના હક, વૃક્ષ કાપવાની અને પરિવહનની પરમિટ, કર, અને કામદારો, વન્યજીવ અને પાણીનું રક્ષણ કરતા કાયદા.',
        'મારા પ્લોટ માટે ખેડૂત ઉત્પાદક જૂથની વ્યવસ્થાપન યોજના અને નિયમોનું પાલન કરવું; મારી પાસેથી માંગવામાં આવેલા રેકોર્ડ રાખવા; મારી જમીન કે તેના ઉપયોગમાં કોઈ પણ ફેરફાર થાય તો ખેડૂત ઉત્પાદક જૂથને જણાવવું.',
        'ફક્ત ખેડૂત ઉત્પાદક જૂથની આંતરિક કાપણી પરમિટ અને જરૂરી હોય તે વન વિભાગની પરમિટ સાથે જ, અને ફક્ત નિશાન કરેલાં વૃક્ષો જ કાપવાં, અને કાપણી પછી ફરીથી વાવેતર કરવું અથવા કુદરતી રીતે ફરી ઊગવા દેવું.',
        'ઝરણાં અને જળાશયોની બાજુમાં, અને ઉચ્ચ સંરક્ષણ મૂલ્ય ધરાવતાં, પવિત્ર અને દફન સ્થળોની આસપાસ બફર પટ્ટી રાખવી; દુર્લભ અને જોખમમાં રહેલાં છોડ અને પ્રાણીઓનું રક્ષણ કરવું, અને તેમનો શિકાર ન કરવો.',
        'કુદરતી જંગલ સાફ ન કરવું કે તેને વાવેતર અથવા બીજા ઉપયોગમાં ન ફેરવવું, અને કોઈ જનીન-સંશોધિત (genetically modified) વૃક્ષ ન વાવવું.',
        'FSC ની અત્યંત જોખમી જંતુનાશકોની યાદીમાંનું કોઈ રસાયણ ન વાપરવું; બીજાં રસાયણો ફક્ત જરૂર હોય ત્યારે જ, રક્ષણાત્મક સાધનો સાથે, સુરક્ષિત સંગ્રહ સાથે અને ખાલી ડબ્બાઓના સુરક્ષિત નિકાલ સાથે વાપરવાં; ક્યારેય અવશેષો ન બાળવા.',
        'કાયદેસર કામની ઉંમરથી નાના કોઈ બાળકને કામે ન રાખવું, બળજબરીથી મજૂરી ન કરાવવી, કોઈની સાથે ભેદભાવ ન કરવો, કામદારોના સંગઠિત થવાના અધિકારનો આદર કરવો, ઓછામાં ઓછું લઘુતમ વેતન ચૂકવવું અને રક્ષણાત્મક સાધનો તથા પ્રાથમિક સારવાર સાથે કામદારોને સુરક્ષિત રાખવા.',
        'પડોશીઓ અને સમુદાયોના રસ્તા, પાણી અને જંગલની પેદાશો પરના પરંપરાગત હકોનો આદર કરવો, અને વિવાદો ખેડૂત ઉત્પાદક જૂથની પ્રક્રિયા દ્વારા ઉકેલવા.',
        'ખેડૂત ઉત્પાદક જૂથ, પ્રમાણન સંસ્થા, FSC અને તેની માન્યતા સેવા (ASI) ને મારા પ્લોટ પર આવવા દેવા, અને મારા રેકોર્ડ જોવા દેવા.',
        '{org}, પ્રમાણન સંસ્થા અથવા ચકાસણીકર્તાએ નોંધેલાં કોઈ પણ અવલોકનો કે સુધારાત્મક પગલાંનો નક્કી થયેલા સમયમાં ઉકેલ લાવવો. હું સમજું છું કે ઉકેલ ન આવેલા મુદ્દાઓ સંબંધિત કાર્યક્રમ કે દાવામાં મારા પ્લોટ કે પેદાશના સમાવેશને અસર કરી શકે છે.',
        'FSC દાવાવાળી પેદાશ ફક્ત ખેડૂત ઉત્પાદક જૂથ મારફતે જ, બિલ પર તેના પ્રમાણપત્ર કોડ સાથે વેચવી, અને FSC નું નામ કે લોગો ફક્ત ખેડૂત ઉત્પાદક જૂથ મંજૂરી આપે તે રીતે જ વાપરવો.',
      ],
      rights: ['મારો પ્લોટ નિયમોનું પાલન કરે ત્યાં સુધી, ખેડૂત ઉત્પાદક જૂથ મારફતે FSC દાવા સાથે મારી પેદાશ વેચવાનો.', 'ખેડૂત ઉત્પાદક જૂથના નિયમો અને મારા પ્લોટની વ્યવસ્થાપન યોજના જોવાનો.'],
    },
    FSC_CW: {
      title: 'FSC નિયંત્રિત લાકડું - Controlled Wood (ચકાસણી)',
      about: 'જે લાકડું FSC પ્રમાણિત નથી, તે પણ સ્વીકાર્ય સ્રોતમાંથી આવે છે એવી ચકાસણી થાય તો FSC Controlled Wood તરીકે વેચી શકાય છે. મારા પ્લોટની એ માટે ચકાસણી થયેલી છે.',
      obligations: [
        'મારા પ્લોટનું લાકડું કાયદા મુજબની દરેક પરમિટ અને કર સાથે કાયદેસર રીતે કાપવામાં અને પરિવહન કરવામાં આવે છે.',
        'તે એવી જમીનમાંથી આવતું નથી જ્યાં પડોશીઓ, સમુદાયો કે કામદારોના પરંપરાગત, નાગરિક કે માનવ અધિકારોનો આદર થતો ન હોય.',
        'તે એવા વિસ્તારોમાંથી આવતું નથી જેનાં ઉચ્ચ સંરક્ષણ મૂલ્યોને કાપણીથી જોખમ હોય.',
        'તે વાવેતર કે બીજા ઉપયોગમાં ફેરવાતા કુદરતી જંગલમાંથી આવતું નથી.',
        'તે જનીન-સંશોધિત (genetically modified) વૃક્ષોમાંથી આવતું નથી.',
        'લાકડાનો દરેક જથ્થો ક્યાંથી આવ્યો - પ્લોટ, જાત અને પ્રમાણ - તેની સાચી માહિતી આપવી, જેથી તેનો પત્તો લગાવી શકાય.',
        '{org} અને તેના ચકાસણીકર્તાઓને મારા પ્લોટની મુલાકાત લેવા દેવી અને મારી જમીન, પરમિટ અને કાપણીના દસ્તાવેજો જોવા દેવા, અને કોઈ પણ ફેરફાર થાય તો તેમને જણાવવું.',
      ],
      rights: ['ચકાસણી માન્ય રહે ત્યાં સુધી, {org} મારફતે મારું લાકડું FSC Controlled Wood તરીકે વેચવાનો.'],
    },
    EUDR: {
      title: 'યુરોપિયન યુનિયનનો વનનાબૂદી નિયમ (EUDR)',
      about: 'યુરોપિયન યુનિયનમાં વેચાતાં લાકડું અને બીજી પેદાશો 31 ડિસેમ્બર 2020 પછીની વનનાબૂદીથી મુક્ત છે અને કાયદેસર રીતે ઉત્પન્ન થયેલાં છે એ સાબિત કરવું પડે છે. {org} એક ડ્યુ ડિલિજન્સ નિવેદન (due diligence statement) રજૂ કરે છે જેમાં મારો પ્લોટ સામેલ છે.',
      obligations: [
        'મારા પ્લોટની સીમા (તેનું ભૌગોલિક સ્થાન) નોંધવા દેવી, અને ડ્યુ ડિલિજન્સ નિવેદનોમાં ખરીદદારો અને EU સત્તાવાળાઓ સાથે વહેંચવા દેવી.',
        '31 ડિસેમ્બર 2020 પછી મારા પ્લોટને વનનાબૂદી અને જંગલની અધોગતિથી મુક્ત રાખવો.',
        'ભારતના કાયદા મુજબ કાયદેસર રીતે ઉત્પાદન કરવું: જમીન વાપરવાના હક, પર્યાવરણ અને વનના નિયમો, જમીન પરના બીજાઓના હક, શ્રમ અને માનવ અધિકારો, લાગુ પડે ત્યાં મુક્ત, પૂર્વ અને જાણકાર સંમતિ, કર, ભ્રષ્ટાચાર-વિરોધી, વેપાર અને કસ્ટમ્સ.',
        'મારી જમીન, મારી કાપણી અને મારી પેદાશ ક્યાં જાય છે તેની સાચી માહિતી આપવી, અને આ પ્લોટની પેદાશને બીજે ક્યાંયની પેદાશથી અલગ રાખવી.',
        'પ્લોટની સીમા, ઉપયોગ કે માલિકીમાં કોઈ પણ ફેરફાર થાય, અને તેના પર કોઈ પણ સફાઈ (વૃક્ષો કાઢવાં) થાય, તો તરત {org} ને જણાવવું.',
        'નિયમ મુજબ, {org} આ માહિતી ઓછામાં ઓછાં પાંચ વર્ષ સુધી રાખે, અને સત્તાવાળાઓને બતાવે, તે માટે મંજૂરી આપવી.',
      ],
      rights: ['મારા પ્લોટ વિશે શું વહેંચવામાં આવે છે, અને કોની સાથે, તે જાણવાનો.'],
    },
    GLOBALGAP: {
      title: 'GLOBALG.A.P. (સારી કૃષિ પદ્ધતિ)',
      about: 'GLOBALG.A.P. છૂટક વેપારીઓને વેચાતા ખોરાક અને છોડ માટે સુરક્ષિત અને ટકાઉ ખેતીનું પ્રમાણપત્ર આપે છે. મારો પ્લોટ {org} ના જૂથ પ્રમાણપત્રમાં છે.',
      obligations: [
        'ખેડૂત ઉત્પાદક જૂથની ગુણવત્તા વ્યવસ્થાપન પદ્ધતિ અને નિયમોનું પાલન કરવું, અને દર વર્ષે તેનાં આંતરિક નિરીક્ષણોમાં ભાગ લેવો.',
        'હું શું વાવું છું, કયાં ખાતર-દવા ક્યારે નાખું છું, અને મારી કાપણીનો રેકોર્ડ રાખવો, જેથી દરેક જથ્થાનો પત્તો મારા પ્લોટ સુધી લગાવી શકાય; પ્રમાણિત અને બીજી પેદાશને અલગ રાખવી.',
        'પાક માટે માન્ય હોય તેવી જ પાક સંરક્ષણ દવાઓ, યોગ્ય માત્રામાં, તાલીમ પામેલી વ્યક્તિ દ્વારા રક્ષણાત્મક સાધનો સાથે વાપરવી, અને કાપણી પહેલાંના પ્રતીક્ષા સમયગાળાનું પાલન કરવું; તેમને તાળામાં રાખવી અને ખાલી ડબ્બાઓનો સુરક્ષિત નિકાલ કરવો.',
        'ખાતરના વપરાશની નોંધ રાખવી; માનવ ગટરનો કાદવ (sewage sludge) ન વાપરવો; જે હેતુ માટે પાણી વપરાય તે માટે સુરક્ષિત હોય એવું જ પાણી વાપરવું.',
        'પેદાશ, કાપણીનાં સાધનો અને વાસણો સ્વચ્છ રાખવાં, અને ચૂંટનારાઓ માટે હાથ ધોવાની અને શૌચાલયની સુવિધા રાખવી.',
        'કામદારોને સુરક્ષિત, તાલીમબદ્ધ અને માહિતગાર રાખવા, પ્રાથમિક સારવાર, પીવાનું સ્વચ્છ પાણી અને ન્યાયી વર્તન સાથે.',
        'કચરો અને પ્રદૂષણ યોગ્ય રીતે સંભાળવાં; મારા પ્લોટ પર અને તેની આસપાસ જમીન, પાણી અને વન્યજીવનું રક્ષણ કરવું.',
        'કોઈ પણ ફરિયાદ, દૂષણ કે ખોરાક સલામતીની સમસ્યા હોય તો તરત ખેડૂત ઉત્પાદક જૂથને જણાવવું, અને જરૂર પડે તો માલ પાછો ખેંચવા કે પાછો મંગાવવાની કાર્યવાહીમાં ભાગ લેવો.',
        'ખેડૂત ઉત્પાદક જૂથના નિરીક્ષકો અને પ્રમાણન સંસ્થાને મારા પ્લોટ અને રેકોર્ડનું નિરીક્ષણ કરવા દેવું, અને અવશેષ તપાસ માટે નમૂના લેવા દેવા.',
      ],
      rights: ['મારો પ્લોટ નિયમોનું પાલન કરે ત્યાં સુધી, મારી પેદાશ GLOBALG.A.P. પ્રમાણિત તરીકે વેચવાનો.'],
    },
    PEFC: {
      title: 'PEFC (ટકાઉ વન વ્યવસ્થાપન)',
      about: 'PEFC ટકાઉ રીતે સંભાળાતાં જંગલો અને વૃક્ષ ખેતરોને પ્રમાણિત કરે છે. મારો પ્લોટ {org} ના ખેડૂત ઉત્પાદક જૂથના ભાગ રૂપે પ્રમાણિત છે.',
      obligations: [
        'મારી જમીન પર વન, પર્યાવરણ, શ્રમ અને કર કાયદા સહિત કાયદાનું પાલન કરવું, અને વૃક્ષ કાપવા તથા પરિવહન માટે જરૂરી પરમિટ રાખવી.',
        'ખેડૂત ઉત્પાદક જૂથની યોજના મુજબ મારાં વૃક્ષોની સંભાળ રાખવી: તેમને ઉત્પાદક અને તંદુરસ્ત રાખવાં, જેટલું ફરી ઊગે તેથી વધુ ન કાપવું, અને ફરીથી વાવેતર કરવું અથવા કુદરતી રીતે ફરી ઊગવા દેવું.',
        'જંગલને બીજા જમીન ઉપયોગમાં ન ફેરવવું, અને કોઈ જનીન-સંશોધિત (genetically modified) વૃક્ષ ન વાવવું.',
        'જમીન અને પાણીનું રક્ષણ કરવું, ઝરણાંની બાજુમાં બફર પટ્ટી રાખવી, અને મારા પ્લોટ પરની જૈવવિવિધતા અને પર્યાવરણની દૃષ્ટિએ મહત્ત્વના વિસ્તારોનું રક્ષણ કરવું.',
        'અત્યંત કે ખૂબ જોખમી તરીકે વર્ગીકૃત કોઈ જંતુનાશક ન વાપરવી; રસાયણો ફક્ત જરૂર હોય ત્યારે જ, સુરક્ષિત રીતે અને લેબલ પર લખ્યા મુજબ વાપરવાં.',
        'કામદારોના મૂળભૂત અધિકારોનો આદર કરવો - બાળ મજૂરી કે બળજબરીથી મજૂરી નહીં, ભેદભાવ નહીં, સંગઠિત થવાની સ્વતંત્રતા - અને તેમને સુરક્ષિત રાખવા.',
        'સ્થાનિક સમુદાયોના અધિકારો, અને મારા પ્લોટ પર કે તેની નજીકનાં સાંસ્કૃતિક અને ધાર્મિક સ્થળોનો આદર કરવો.',
        'મારી પાસેથી માંગવામાં આવેલા રેકોર્ડ રાખવા, ખેડૂત ઉત્પાદક જૂથ અને પ્રમાણન સંસ્થાનાં ઓડિટ થવા દેવાં, અને તેઓ જે સુધારાત્મક પગલાં નોંધે તેનો નક્કી થયેલા સમયમાં ઉકેલ લાવવો.',
        'PEFC દાવાવાળું લાકડું ફક્ત ખેડૂત ઉત્પાદક જૂથ મારફતે જ વેચવું, અને PEFC નું નામ કે લોગો ફક્ત ખેડૂત ઉત્પાદક જૂથ મંજૂરી આપે તે રીતે જ વાપરવો.',
      ],
      rights: ['મારો પ્લોટ નિયમોનું પાલન કરે ત્યાં સુધી, ખેડૂત ઉત્પાદક જૂથ મારફતે PEFC દાવા સાથે મારું લાકડું વેચવાનો.'],
    },
    ORGANIC: {
      title: 'સજીવ ખેતી - ઓર્ગેનિક (NPOP / NOP)',
      about: 'ઓર્ગેનિક પ્રમાણપત્ર બતાવે છે કે પેદાશ રાસાયણિક (કૃત્રિમ) ખાતર અને જંતુનાશકો વિના ઉગાડવામાં આવી છે. મારો પ્લોટ {org} ના ઓર્ગેનિક ઉત્પાદક જૂથમાં, તેની આંતરિક નિયંત્રણ પદ્ધતિ હેઠળ છે.',
      obligations: [
        'મારી પેદાશ ઓર્ગેનિક તરીકે વેચાય તે પહેલાં રૂપાંતર સમયગાળો પૂરો કરવો.',
        'કોઈ રાસાયણિક ખાતર, જંતુનાશક, નીંદણનાશક કે વૃદ્ધિ નિયંત્રક ન વાપરવું, કોઈ જનીન-સંશોધિત બીજ કે વાવેતર સામગ્રી ન વાપરવી, અને ગટરનો કાદવ (sewage sludge) ન વાપરવો.',
        'ઓર્ગેનિક ધોરણ મંજૂરી આપે તેવી જ સામગ્રી વાપરવી, અને તેનાં બિલ અને લેબલ સાચવી રાખવાં.',
        'પડોશનાં સામાન્ય (રાસાયણિક) ખેતરોથી બફર પટ્ટી રાખવી, અને ત્યાંથી આવતા છંટકાવ અને દૂષણને અટકાવવું.',
        'જો હું સામાન્ય (રાસાયણિક) પાક પણ ઉગાડું, તો તેને સ્પષ્ટ રીતે અલગ રાખવો, અને ક્યારેય સામાન્ય પેદાશને ઓર્ગેનિક સાથે ભેળવવી નહીં.',
        'મારી સામગ્રી, કાપણી અને વેચાણનો રેકોર્ડ રાખવો; ઓર્ગેનિક પેદાશ માટે સ્વચ્છ, અલગ થેલીઓ અને ગોદામ વાપરવાં.',
        'આંતરિક નિયંત્રણ પદ્ધતિના નિયમોનું પાલન કરવું, તેની તાલીમમાં હાજરી આપવી, અને તેનાં નિરીક્ષણો અને નમૂના તપાસ થવા દેવાં; હું સમજું છું કે કોઈ જરૂરિયાત પૂરી ન થાય તો મારી પેદાશ ઓર્ગેનિક તરીકે વેચી શકાય કે નહીં તેના પર અસર પડી શકે છે.',
        'પેદાશ ઓર્ગેનિક તરીકે ફક્ત ખેડૂત ઉત્પાદક જૂથ મારફતે જ વેચવી, અને ખેડૂત ઉત્પાદક જૂથ મંજૂરી આપે તે રીતે જ તેના પર લેબલ લગાવવું.',
        'કોઈ પ્રતિબંધિત પદાર્થનો ઉપયોગ, દૂષણ, કે મારી જમીનમાં ફેરફાર થાય તો તરત ખેડૂત ઉત્પાદક જૂથને જણાવવું.',
      ],
      rights: ['મારો પ્લોટ નિયમોનું પાલન કરે ત્યાં સુધી, ખેડૂત ઉત્પાદક જૂથ મારફતે મારી પેદાશ ઓર્ગેનિક તરીકે વેચવાનો.'],
    },
    CARBON: {
      title: 'કાર્બન પ્રોજેક્ટ',
      about: 'મારા પ્લોટ પરનાં વૃક્ષો કાર્બન સંગ્રહ કરે છે. {org} મારા પ્લોટને એક કાર્બન પ્રોજેક્ટમાં સામેલ કરે છે જે તેનું માપ કાઢે છે અને તેના માટે કાર્બન ક્રેડિટ વેચી શકે છે.',
      obligations: [
        'પ્રોજેક્ટ કરારમાં લખ્યા મુજબ, મારા પ્લોટ પરનાં પ્રોજેક્ટ વૃક્ષોની કાર્બન ક્રેડિટનો હક, તેના ક્રેડિટ સમયગાળા માટે, પ્રોજેક્ટને સોંપવો.',
        'પ્રોજેક્ટના સમયગાળા દરમિયાન પ્રોજેક્ટ વૃક્ષોને ઊભાં રાખવાં; તેમાંથી કોઈ પણ કાપતાં પહેલાં {org} ને જણાવવું, અને જે સુકાઈ કે મરી જાય તેની જગ્યાએ નવાં વાવવાં.',
        'એ જ વૃક્ષો કે જમીનને બીજા કોઈ કાર્બન પ્રોજેક્ટ કે યોજનામાં નોંધાવવી નહીં, અને તેમનો કાર્બન બીજા કોઈને વેચવો નહીં.',
        'અહીં જે સફાઈ કે કાપણી હું કરત, તે બીજી જમીન પર ખસેડવી નહીં (લીકેજ).',
        'પ્રોજેક્ટને વૃક્ષોનું માપ લેવા, મારા પ્લોટનો નકશો બનાવવા, અને સેટેલાઇટ દ્વારા તેની દેખરેખ રાખવા દેવી, અને એ આંકડા રજિસ્ટ્રી, ચકાસણીકર્તા અને ક્રેડિટના ખરીદદારો સાથે વહેંચવા દેવા.',
        'પ્રોજેક્ટ વૃક્ષોને અસર કરતી કોઈ પણ આગ, નુકસાન, વિવાદ કે માલિકીના ફેરફાર વિશે {org} ને જણાવવું.',
      ],
      rights: ['પ્રોજેક્ટ કરારમાં લખેલો કાર્બન આવકનો હિસ્સો મેળવવાનો, અને તેની ગણતરી કેવી રીતે થાય છે તે જોવાનો.', 'આ દસ્તાવેજ દ્વારા આપેલી, પ્રોજેક્ટ માટેની મુક્ત, પૂર્વ અને જાણકાર સંમતિનો.'],
    },
  },
  membershipDuties: [
    'મારા પ્લોટ માટે કાર્યક્રમની જરૂરિયાતોનું પાલન કરવું, અને મારી જમીન, તેની માલિકી કે તેના ઉપયોગમાં કોઈ પણ ફેરફાર થાય તો {org} ને જણાવવું.',
    'તાલીમ, આંતરિક નિરીક્ષણો અને ઓડિટમાં ભાગ લેવો, અને કોઈ પણ સુધારાત્મક પગલાંનો નક્કી થયેલા સમયમાં ઉકેલ લાવવો.',
    'હું સમજું છું કે દરેક કાર્યક્રમની પોતાની જરૂરિયાતો છે. મારો પ્લોટ અને પેદાશ લાગુ પડતા કાર્યક્રમની જરૂરિયાતો પૂરી કરતાં રહે છે કે નહીં તે નક્કી કરવા {org} મારા પ્લોટ અને રેકોર્ડની સમીક્ષા કરી શકે છે.',
    'જો કોઈ જરૂરિયાતનું પાલન ન થાય, તો હું સમજું છું કે મારો પ્લોટ કે પેદાશ સંબંધિત કાર્યક્રમ કે દાવામાં સામેલ રહી શકે કે નહીં તેની {org} સમીક્ષા કરી શકે છે.',
    'સાચા રેકોર્ડ રાખવા, અને બીજે ક્યાંયની પેદાશને ક્યારેય મારા પ્લોટની પેદાશ તરીકે ન ખપાવવી.',
  ],
  dataNotice: {
    collected: 'મારું નામ અને કુટુંબની વિગતો, સરનામું, ફોન અને ઈમેલ, ઓળખપત્ર અને જમીનના દસ્તાવેજોના નંબર (છુપાવીને રાખેલા), ફોટોગ્રાફ, મારા પ્લોટની સીમા અને સ્થાન, તેના પરનાં વૃક્ષો અને ખેતી પદ્ધતિઓ, અને મારી કાપણી, વેચાણ અને ચુકવણીઓ.',
    purposes: 'મારી અને મારા પ્લોટની નોંધણી કરવા, આ દસ્તાવેજમાં જણાવેલા કાર્યક્રમો હેઠળ તેને પ્રમાણિત કરવા, મારી પેદાશનો પત્તો રાખવા અને તેના દાવાઓ સાથે વેચવા, ડ્યુ ડિલિજન્સ નિવેદનો રજૂ કરવા, કાર્બન માપવા, અને મને ચુકવણી કરવા.',
    sharedWith: 'જ્યાં સંબંધિત હોય ત્યાં: પ્રમાણન સંસ્થાઓ, ઓડિટરો, કાર્યક્રમ કે ધોરણના માલિકો, ચકાસણીકર્તાઓ, રજિસ્ટ્રીઓ, ખરીદદારો, સપ્લાય-ચેઇન ભાગીદારો, પ્રોજેક્ટ ભાગીદારો અને સરકારી સત્તાવાળાઓ. ખરીદદારો અને સપ્લાય-ચેઇન ભાગીદારોને પેદાશનો પત્તો રાખવા, ચકાસણી, ડ્યુ ડિલિજન્સ, પ્રમાણન કે વેચાણ માટે વાજબી રીતે જરૂરી હોય તેટલી જ માહિતી મળે છે. મારી વ્યક્તિગત માહિતી અસંબંધિત માર્કેટિંગ હેતુઓ માટે વેચવામાં આવશે નહીં.',
    retention: 'આ સંમતિ ચાલુ રહે ત્યાં સુધી, અને તે પછી કાયદો કે કોઈ કાર્યક્રમ માંગે ત્યાં સુધી (EUDR રેકોર્ડ માટે ઓછામાં ઓછાં પાંચ વર્ષ).',
    rights: 'મારા વિશે રાખેલો ડેટા જોવાનો, તેને સુધારાવવાનો કે પૂરો કરાવવાનો, કોઈ કાયદા કે કાર્યક્રમને તેની જરૂર ન રહે ત્યારે તેને ભૂંસાવવાનો, ગમે ત્યારે આ સંમતિ પાછી ખેંચવા માટે કહેવાનો, અને મારા વતી કામ કરવા માટે કોઈને નિયુક્ત કરવાનો.',
  },
  sharing: {
    intro: 'હું સંમત છું કે {org} આ સંમતિમાં વર્ણવેલા હેતુઓ માટે મારા અને મારા પ્લોટ વિશેની માહિતી એકત્ર કરી શકે, નોંધી શકે, વાપરી શકે અને જાળવી શકે. હું {org} ને મારા, મારા પ્લોટ, ઉત્પાદન, કાપણી અને વ્યવહારો વિશેની સંબંધિત માહિતી નીચેના સાથે વહેંચવાની મંજૂરી આપું છું:',
    recipients: [
      'પ્રમાણન સંસ્થાઓ અને ઓડિટરો;',
      'કાર્યક્રમના માલિકો, ધોરણના માલિકો અને ચકાસણી સંસ્થાઓ;',
      'જરૂરી હોય ત્યાં, સરકારી અને નિયમનકારી સત્તાવાળાઓ;',
      'ખરીદદારો અને સપ્લાય-ચેઇન ભાગીદારો, જ્યાં પેદાશનો પત્તો રાખવા, દાવાની ચકાસણી, ડ્યુ ડિલિજન્સ કે વ્યવહારની જરૂરિયાતો માટે માહિતીની જરૂર હોય;',
      'લાગુ પડે ત્યાં, કાર્બન પ્રોજેક્ટ રજિસ્ટ્રીઓ, ચકાસણીકર્તાઓ અને સંબંધિત પ્રોજેક્ટ ભાગીદારો; અને',
      'નકશા બનાવવા, દેખરેખ, ડેટા વ્યવસ્થાપન કે ચકાસણીમાં મદદ કરતા સેવા પ્રદાતાઓ.',
    ],
    limits: [
      'ફક્ત લાગુ પડતા કાર્યક્રમ, દાવા, ચકાસણી, પેદાશનો પત્તો રાખવા કે વ્યવહાર સાથે સંબંધિત માહિતી જ વહેંચવામાં આવશે.',
      '{org} મારી વ્યક્તિગત માહિતી અસંબંધિત માર્કેટિંગ હેતુઓ માટે વેચશે નહીં.',
      'હું સમજું છું કે પેદાશનું મૂળ અને નિયમોનું પાલન બતાવવા માટે મારા પ્લોટ વિશેની કેટલીક માહિતી, જેમ કે તેનું સ્થાન, ઉત્પાદન, કાપણી અને પત્તો રાખવાની માહિતી, વહેંચવી પડી શકે છે.',
    ],
    statements: [
      'હું સંમત છું કે મૂળ, પત્તો રાખવાની ક્ષમતા, પ્રમાણપત્રના દાવા, ડ્યુ ડિલિજન્સ કે નિયમ પાલનની જરૂરિયાતો બતાવવા માટે જરૂરી હોય ત્યારે, મારા પ્લોટ અને પેદાશ વિશેની સંબંધિત માહિતી ખરીદદારો અને સપ્લાય-ચેઇન ભાગીદારો સાથે વહેંચી શકાય.',
      'હું સંમત છું કે આ સંમતિમાં આવરી લેવાયેલા હેતુઓ માટે ફોટોગ્રાફ, પ્લોટના નકશા, ઉત્પાદનની માહિતી, કાપણીની માહિતી અને સંબંધિત રેકોર્ડ અધિકૃત કાર્યક્રમ, પ્રમાણન, ચકાસણી અને પ્રોજેક્ટ સંસ્થાઓ સાથે વહેંચી શકાય.',
    ],
    withdrawal: 'હું ગમે ત્યારે મારી સંમતિ પાછી ખેંચવા માટે કહી શકું છું. સંબંધિત કાર્યક્રમ, પ્રમાણપત્ર, દાવા કે પ્રોજેક્ટમાં મારી ભાગીદારી પર સંમતિ પાછી ખેંચવાની શું અસર થઈ શકે તે {org} મને સમજાવશે. સંમતિ પાછી ખેંચતાં પહેલાં વાપરેલી કે વહેંચેલી માહિતી, રેકોર્ડ, કાયદા, પ્રમાણન, પત્તો રાખવાની કે કાર્યક્રમની જરૂરિયાતો માટે જરૂરી હોય ત્યાં સાચવી રાખવામાં આવી શકે છે.',
  },
};
